import { Stack, Text } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { Notification } from '@eti/components';
import variants from '@eti/components/dist/utils/variants';
import TitledCard from '../../../../../common/components/TitledCard';

interface GeneralInfoProps {
  carrierName: string;
  carrierBookingNumbersCount: number;
}

const GeneralInfo = ({ carrierName, carrierBookingNumbersCount }: GeneralInfoProps) => {
  const { t } = useTranslation();

  return (
    <TitledCard
      data-testid="general-info-section"
      headingAs="h3"
      headingLevel={2}
      title={t('OrderDetails.CarrierVerification.Notification.Title', carrierName)}
    >
      <Stack spacing={16}>
        <Notification dataTestId="general-info-notification" variant={variants.WARNING}>
          <Text>
            {t('OrderDetails.CarrierVerification.Drawer.GeneralInfo.Notification', carrierName)}
          </Text>
        </Notification>
        <Text asHtml>
          {t('OrderDetails.CarrierVerification.Drawer.GeneralInfo.Description', carrierName)}
        </Text>
        {carrierBookingNumbersCount > 1 && (
          <Text asHtml>
            {t(
              'OrderDetails.CarrierVerification.Drawer.GeneralInfo.MultiBookingNums.Description',
              carrierBookingNumbersCount,
              carrierName,
            )}
          </Text>
        )}
      </Stack>
    </TitledCard>
  );
};

export default GeneralInfo;
